import { invoicesCredits } from './invoices-credits-en.i18n';

export const en = {
  invoicesCredits,
};
